import React from 'react'
import PropTypes from 'prop-types'
import Button from '@components/button/button.component'
import Icon from '@components/icon/icon.component'

import useStyles from './searchlight-action-item.style'
import { GREEN } from '@omnilert/components'

const SearchlightActionItem = ({ action, actionTaken, onClick }) => {
  const { description, icon, title } = action
  const itemIsSelected = actionTaken === action.actionId

  const classes = useStyles({ itemIsSelected, actionTaken })

  const handleClick = () => {
    if (actionTaken) return null
    onClick(action)
  }

  return (
    <Button
      backgroundColor='var(--primary__page__background)'
      className={classes.button}
      onClick={handleClick}
    >
      <div className={classes.carouselItem}>
        <div className={classes.icon}>
          <Icon
            strokeColor={itemIsSelected ? GREEN : null}
            type={itemIsSelected ? 'check' : icon}
          />
        </div>
        <div className={classes.title}>{title}</div>
        <div className={classes.description}>{description}</div>
        <div />
      </div>
    </Button>
  )
}

SearchlightActionItem.propTypes = {
  actionTaken: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  action: PropTypes.object.isRequired
}

export default SearchlightActionItem
